module.exports = __webpack_public_path__ + "b66b591713e09de4ef871bc5970254e8.svg";